// extracted by mini-css-extract-plugin
export var card = "_am-0";
export var expandedCard = "_am-2";
export var paginated = "_am-1";